export const INIT = 'app/FormPage/INIT';
export const INIT_SUCCESS = 'app/FormPage/INIT_SUCCESS';
export const INIT_FAILED = 'app/FormPage/INIT_FAILED';

export const REMOVE = 'app/FormPage/REMOVE';
export const REMOVE_SUCCESS = 'app/FormPage/REMOVE_SUCCESS';
export const REMOVE_FAILED = 'app/FormPage/REMOVE_FAILED';

export const TOGGLE_FORM_RESPONSE_OVERLAY = 'app/FormPage/TOGGLE_FORM_RESPONSE_OVERLAY';
